var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { isValidPath } from '../../common/utils/_.utils';
import { ControlError } from './ControlError';
import { Tree } from 'primereact/tree';
import { Menubar } from 'primereact/menubar';
import { omit } from 'ramda';
var MenuControl = /** @class */ (function (_super) {
    __extends(MenuControl, _super);
    function MenuControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign(__assign({}, _this.state), { selectedKey: '', expandedKeys: {} });
        _this.menuRef = null;
        _this.onNodeSelect = function (o) {
            var node = o.node;
            if (node.children && node.children.length) {
                node.toggle();
            }
            if (node.showBlock) {
                _this.handleChange(node.showBlock);
            }
            if (node.path) {
                _this.handleUrlChange(node.path);
            }
        };
        _this.handleUrlChange = function (path) {
            if (isValidPath.test(path)) {
                window.location.href = path;
            }
        };
        return _this;
    }
    MenuControl.prototype.componentDidMount = function () {
        var _a;
        var _b = this.state.def, frontOptions = _b.frontOptions, supportedValues = _b.supportedValues;
        var supportedValuesOptions = frontOptions.supportedValues;
        var options = supportedValuesOptions || supportedValues;
        var nodes = this.mapValuesToTreeMenu(options);
        var defaultNode;
        var findDefaultSelected = function (items) {
            items.forEach(function (it) {
                if (it.defaultSelected) {
                    defaultNode = it;
                    return;
                }
                if (it.children) {
                    findDefaultSelected(it.children);
                }
            });
        };
        findDefaultSelected(nodes);
        if (defaultNode) {
            // if defaultSelected field is provided, then select default menu item and set corresponding ui state
            this.onNodeSelect({ originalEvent: null, node: defaultNode });
            this.setState({ selectedKey: defaultNode.key }, this.forceUpdate);
            this.setState({ expandedKeys: (_a = {}, _a[defaultNode.key[0]] = true, _a) });
        }
    };
    MenuControl.prototype.mapValuesToTreeMenu = function (values, parentIndex) {
        var _this = this;
        if (parentIndex === void 0) { parentIndex = ''; }
        return values.map(function (val, i) {
            var label = val.label, items = val.items, showBlock = val.showBlock, path = val.path, icon = val.icon, defaultSelected = val.defaultSelected;
            var isParentNode = items && items.length;
            var key = parentIndex + i;
            return {
                key: key,
                label: label,
                showBlock: showBlock,
                path: path,
                icon: icon,
                style: { cursor: 'pointer', userSelect: 'none' },
                defaultSelected: defaultSelected,
                children: isParentNode ? _this.mapValuesToTreeMenu(val.items, i + '-') : null,
                toggle: function () { return _this.setState(function (prevState) {
                    var _a;
                    return key in prevState.expandedKeys
                        ? { expandedKeys: omit([key], prevState.expandedKeys) }
                        : { expandedKeys: __assign(__assign({}, prevState.expandedKeys), (_a = {}, _a[key] = true, _a)) };
                }, _this.forceUpdate); }
            };
        });
    };
    MenuControl.prototype.mapValuesToMenubar = function (values, parentIndex) {
        var _this = this;
        if (parentIndex === void 0) { parentIndex = ''; }
        return values.map(function (val, i) {
            var showBlock = val.showBlock, path = val.path, items = val.items;
            var isParentNode = items && items.length;
            var key = parentIndex + i;
            var commandHandler = function () {
                if (showBlock) {
                    _this.handleChange(showBlock);
                }
                if (path) {
                    _this.handleUrlChange(path);
                }
                if (key) {
                    _this.setState({ selectedKey: key });
                }
            };
            return __assign(__assign({}, val), { key: key, command: commandHandler, className: key === _this.state.selectedKey ? 'active' : null, items: isParentNode ? _this.mapValuesToMenubar(val.items, i + '-') : null });
        });
    };
    ;
    MenuControl.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions, supportedValues = def.supportedValues;
        var hint = frontOptions.hint, fixPos = frontOptions.fixPos, orientation = frontOptions.orientation, supportedValuesOptions = frontOptions.supportedValues, restOptions = __rest(frontOptions, ["hint", "fixPos", "orientation", "supportedValues"]);
        var options = supportedValuesOptions || supportedValues;
        var computed = this.menuRef && window.getComputedStyle(this.menuRef).getPropertyValue("padding");
        var style = fixPos ? __assign(__assign({}, frontOptions.style), { position: 'fixed', width: this.menuRef && (this.menuRef.offsetWidth - 2 * parseFloat(computed)) + 'px' }) : frontOptions.style;
        var props = __assign(__assign({}, omitSpecialProperties(restOptions)), { key: def.id, id: def.id });
        var menuRender = orientation === 'vertical' ? (React.createElement(Tree, __assign({}, props, { selectionMode: "single", onToggle: function () { return void 0; }, selectionKeys: this.state.selectedKey, onSelectionChange: function (e) { return _this.setState({ selectedKey: e.value }, _this.forceUpdate); }, onSelect: this.onNodeSelect, expandedKeys: this.state.expandedKeys, style: style, value: this.mapValuesToTreeMenu(options) }))) : (React.createElement(Menubar, __assign({}, props, { model: this.mapValuesToMenubar(options) })));
        return React.createElement("div", { id: "menu-container", ref: function (ref) { return ref && (_this.menuRef = ref); }, className: mapElementClass(restOptions) },
            menuRender,
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    return MenuControl;
}(FormBaseElement));
export { MenuControl };
//# sourceMappingURL=Menu.js.map